import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import { Dropdown } from 'react-bootstrap'
import { TopLabelFormGroup, Button } from ".."
import { IconChevronRightDropdown } from "../../../assests/icons"
import "./style.scss";

const OPTIONS = [
  {
    value: "10",
    label: "10"
  },
  {
    value: "20",
    label: "20"
  },
  {
    value: "50",
    label: "50"
  },
  {
    value: "100",
    label: "100"
  }
]
const TopFilterTable = ({ className, isSearch, pageSize, onPageSizeChange, onClick, isAdd, textButton, onSearch, searchText }) => {
  return (
    <div className={cn('topFilterTable', [className])}>
      <Dropdown className="topFilterTable__dropDown" size="sm">
        Show
        <Dropdown.Toggle >
          {pageSize} <IconChevronRightDropdown />
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {OPTIONS.map(item => (
            <Dropdown.Item onClick={() => { onPageSizeChange(item.value) }} key={item.label} >{item.label}</Dropdown.Item>
          ))}

        </Dropdown.Menu>
      </Dropdown>

      <div className="topFilterTable__group">
        {
          isSearch ? (
            <TopLabelFormGroup
              isSearch
              placeholder="Search"
              controlId="Search"
              value={searchText}
              onChange={(_, value) => {

                onSearch(value)
              }}
              isTextArea={false}
            />
          ) : null
        }
        {isAdd ? <Button onClick={() => { onClick() }} className="topFilterTable__button" typeClass="second" size="md" text={textButton} /> : null}

      </div>


    </div>
  )
};

TopFilterTable.propTypes = {
  isSearch: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.any,
  ]),
  className: PropTypes.string,
  pageSize: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.any,
  ]),
  onPageSizeChange: PropTypes.func,
  onClick: PropTypes.func,
  isAdd: PropTypes.bool,
  textButton: PropTypes.string,
  onSearch: PropTypes.func,
  searchText: PropTypes.string,
};

TopFilterTable.defaultProps = {
  isSearch: false,
  className: "",
  pageSize: "10",
  onPageSizeChange: () => { },
  onClick: () => { },
  isAdd: false,
  textButton: "Add New User",
  onSearch: () => { },
  searchText: ""
}

export default TopFilterTable;
